const ADDONS_TYPES = {
  FOR_BAG: 'EVERY',
  FOR_DIET: 'FIRST',
  EVERY: 'EVERY',
  FIRST: 'FIRST',
};

export default ADDONS_TYPES;
